import { FC, useEffect, useRef } from "react";

interface ThumbnailGeneratorProps {
  videoSrc: string | null;
  onThumbnailGenerated: (thumbnailUrl: string) => void;
}

export const ThumbnailGenerator: FC<ThumbnailGeneratorProps> = ({
  videoSrc,
  onThumbnailGenerated,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoSrc && videoRef.current) {
      const video = videoRef.current;

      const handleMetadata = () => {
        video.currentTime = Math.min(0.5, video.duration * 0.1);
      };

      const handleSeeked = () => {
        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext("2d");

        if (ctx) {
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          canvas.toBlob(
            (blob) => {
              if (blob) {
                const thumbnailUrl = URL.createObjectURL(blob);
                onThumbnailGenerated(thumbnailUrl);
              }
            },
            "image/jpeg",
            0.7,
          );
        }
      };

      video.addEventListener("loadedmetadata", handleMetadata);
      video.addEventListener("seeked", handleSeeked);

      return () => {
        video.removeEventListener("loadedmetadata", handleMetadata);
        video.removeEventListener("seeked", handleSeeked);
      };
    }
  }, [videoSrc, onThumbnailGenerated]);

  return (
    <video
      ref={videoRef}
      src={videoSrc || undefined}
      style={{ display: "none" }}
      muted
      playsInline
    />
  );
};

export default ThumbnailGenerator;
